import SbgPrintable from "./SbgPrintable";
import {useEffect, useState} from "react";
import {AxiosCustomGet} from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import Cookies from "js-cookie";
import SwalToast from "../../components/helpers/SwalToast";
import {useParams} from "react-router-dom";

const SbgPrivate = () => {
    let {id} = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        AxiosCustomGet(
            `${process.env.REACT_APP_BASE_API_URL}gadai/${id}`,
            Config({
                Authorization: `Bearer ${Cookies.get("access_token")}`
            }),
            (response) => {
                setData(response.data.data);
            },
            (error) => {
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data.error?.message || "Whoops, something went wrong"
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong"
                    });
                }
            }
        );
    };

    return (
        <div className="p-4">
            {data && <>
                <button className="btn btn-sm bgc-2C465C text-white mb-3" onClick={() => window.print()}>Print</button>
                <SbgPrintable data={data} />
            </>}
        </div>
    );
};

export default SbgPrivate;